<script setup lang="ts">
import {
  computed,
  ref,
  watch,
  defineProps,
  defineExpose,
} from "vue";
import type { IFieldValue } from "@/components/form/types";

// interface
interface Props {
  default?: { [key: string]: IFieldValue };
}
const props = defineProps<Props>();

// computed
const isValid = computed<boolean>(() => {
  // oxlint-disable-next-line no-unused-expressions
  tick.value;

  const fields = form.value?.querySelectorAll(".field-group");

  if (!fields) return false;

  for (const field of fields) {
    const valid = field.getAttribute("data-valid");
    if (valid === "false") return false;
  }

  return true;
});

// data
const models = ref<{ [key: string]: IFieldValue }>(props.default ?? {});
const form = ref<HTMLFormElement>();
const tick = ref<number>(0);

// methods
function nextTick() {
  setTimeout(() => {
    tick.value++;
  }, 0);
}
function clear() {
  models.value = {};
}

// watch
watch(models, nextTick, { deep: true });

// expose
defineExpose({ models, clear, nextTick, isValid });
</script>

<template>
  <form
    ref="form"
    class="form"
    @submit.prevent="$emit('submit', { isValid, models })"
  >
    <slot ref="field" :models="models" :is-valid="isValid" :clear="clear" />
  </form>
</template>

<style scoped></style>
